import { resolveComponent, createElementBlock, openBlock, createCommentVNode, createElementVNode, unref, toDisplayString, renderSlot, normalizeClass, createVNode, withCtx, createBlock } from "vue";
import { useDisplay } from "vuetify";
import "../../plugins/apollo.js";
import "lodash-es";
import "moment";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import "../../plugins/i18n.js";
import "../../assets/e94e4817134d7c25.png";
import "../../assets/5341da3ffbec0137.png";
import "../../assets/01f50022317dccd7.png";
import "axios";
import { useRouter } from "../../plugins/router.js";
import "maska";
import { useLocalePath } from "../../composables/useLocalePath.js";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vue-router";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
/* empty css                         */
import "vuetify/components/VDialog";
import "../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import { VCard, VCardText, VCardActions } from "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                  */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../assets/8a32dc557a826bf0.png";
/* empty css                     */
import "../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                               */
import { VSpacer } from "vuetify/components/VGrid";
import "../Base/index.js";
import "vuex";
/* empty css                        */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../icons/mdi/index.js";
/* empty css                            */
import "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                      */
import "vuetify/components/VChip";
/* empty css                          */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                        */
import "../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                 */
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
import "../../graphql/system-settings.js";
import "tiny-emitter/instance";
/* empty css                             */
/* empty css                                    */
import "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                            */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                                             */
/* empty css                 */
import { ENTITY_RECORD_PROPS } from "../../composables/useEntityRecord.js";
import { ENTITY_CARD_PROPS, useEntityCard } from "../../composables/useEntityCard.js";
/* empty css              */
import "vuetify/components";
/* empty css                    */
/* empty css                     */
import "../../graphql/system-events.js";
/* empty css                                        */
/* empty css                         */
import "vuetify/components/VTooltip";
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
/* empty css                            */
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
import "vue-dndrop";
/* empty css                                            */
/* empty css                                    */
import "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
/* empty css                        */
import "vuetify/components/VFileInput";
/* empty css                            */
import "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
import "../../graphql/public-articles.js";
/* empty css                                           */
/* empty css                               */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                  */
import "vuetify/components/VItemGroup";
/* empty css                             */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                        */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
import "../../graphql/session-store.js";
import "../../composables/useModalPage.js";
import "../../icons/portal/index.js";
import "graphql-tag";
import "../../graphql/entity.js";
import "../../graphql/lookups.js";
const _hoisted_1 = { class: "b-edit-card" };
const _hoisted_2 = {
  key: 0,
  class: "b-edit-card__header d-flex flex-wrap justify-space-between align-center mb-8 g-2"
};
const _hoisted_3 = {
  key: 0,
  class: "b-edit-card__header-title"
};
const _hoisted_4 = {
  key: 1,
  class: "b-edit-card__header-actions d-flex align-center g-2"
};
const _sfc_main = {
  __name: "BaseCard",
  props: {
    // --- Entity Record Composable Props ---
    ...ENTITY_RECORD_PROPS,
    ...ENTITY_CARD_PROPS,
    // --- Card Props ---
    sectionPath: {
      type: String
    },
    closeOnCreate: {
      type: Boolean,
      default: true
    }
  },
  setup(__props, { expose: __expose }) {
    const { mdAndUp } = useDisplay();
    const router = useRouter();
    const localePath = useLocalePath();
    const props = __props;
    const { item, isNew, header, showActions, validate, save, onSaved, reset } = useEntityCard(props);
    const close = () => props.sectionPath ? router.push(localePath(props.sectionPath)) : router.back();
    onSaved(({ isNew: isNew2 }) => {
      if (isNew2 && props.closeOnCreate) {
        close();
      }
    });
    __expose({
      item,
      validate,
      save,
      reset
    });
    return (_ctx, _cache) => {
      const _component_b_btn = resolveComponent("b-btn");
      return openBlock(), createElementBlock("div", _hoisted_1, [
        unref(header) || _ctx.$slots["header-actions"] ? (openBlock(), createElementBlock("div", _hoisted_2, [
          unref(header) ? (openBlock(), createElementBlock("span", _hoisted_3, toDisplayString(unref(header)), 1)) : createCommentVNode("", true),
          _ctx.$slots["header-actions"] ? (openBlock(), createElementBlock("div", _hoisted_4, [
            renderSlot(_ctx.$slots, "header-actions", {
              item: unref(item),
              isNew: unref(isNew)
            })
          ])) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        createElementVNode("div", {
          class: normalizeClass([
            "b-edit-card__wrapper",
            unref(mdAndUp) ? "g-12" : "g-6 flex-column"
          ])
        }, [
          createVNode(VCard, {
            class: normalizeClass([
              "b-edit-card__form",
              {
                "no-actions": !unref(showActions)
              }
            ]),
            rounded: "xl",
            flat: ""
          }, {
            default: withCtx(() => [
              !_ctx.hideActions ? (openBlock(), createBlock(_component_b_btn, {
                key: 0,
                class: "close-button",
                preset: "closeMini",
                onClick: close
              })) : createCommentVNode("", true),
              createVNode(VCardText, { class: "b-edit-card__content pa-0" }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "default", {
                    item: unref(item),
                    isNew: unref(isNew)
                  })
                ]),
                _: 3
              }),
              createVNode(VSpacer),
              unref(showActions) ? (openBlock(), createBlock(VCardActions, {
                key: 1,
                class: "g-4 mt-8 mx-auto mr-lg-0 px-4 pr-0"
              }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "actions", {}, () => [
                    createVNode(_component_b_btn, {
                      class: "b-edit-card__form__button",
                      preset: "cancel",
                      text: _ctx.$t("base.buttons.reset"),
                      onClick: unref(reset)
                    }, null, 8, ["text", "onClick"]),
                    createVNode(_component_b_btn, {
                      class: "b-edit-card__form__button",
                      preset: "save",
                      onClick: unref(save)
                    }, null, 8, ["onClick"])
                  ])
                ]),
                _: 3
              })) : createCommentVNode("", true)
            ]),
            _: 3
          }, 8, ["class"])
        ], 2)
      ]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
